module.exports = __webpack_public_path__ + "static/media/MicrosoftEdge_ai.ad6e0e9b.png";